import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';

import { User } from '@/core/models/user.model';
import { SessionStorageService } from '@/core/services/internal/session-storage.service';

const TOKEN_KEY = 'token';
const USER_KEY = 'current-user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor(private sessionStorageService: SessionStorageService) { }

  signOut(): void {
    this.sessionStorageService.clearStorage();
  }

  public saveToken(token: string): void {
    this.sessionStorageService.deleteItem(TOKEN_KEY);
    this.sessionStorageService.saveItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return this.sessionStorageService.getItem(TOKEN_KEY);
  }

  public saveUser(user: User): void {
    this.sessionStorageService.deleteItem(USER_KEY);
    this.sessionStorageService.saveItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): User | null {
    const stored = this.sessionStorageService.getItem(USER_KEY);
    if (!stored) return null;

    try {
      const parsed = JSON.parse(stored);
      const userInstance = plainToInstance(User, parsed);
      return Array.isArray(userInstance) ? userInstance[0] : userInstance;
    } catch (e) {
      console.error('Invalid user data in session storage:', e);
      return null;
    }
  }
}
